import { useSerialIds } from "highcharts";
import React, { useEffect, useState, useContext } from "react";
import appFetch from "../appFetch";
import apiEndpoints from "../apiEndpoints";
import styled from "styled-components";
import { Formik, Form as FormikForm, Field, ErrorMessage } from "formik";
import { LockClosedIcon, UserIcon, MailIcon } from "@heroicons/react/solid";
import Spinner from "../loaders/Spinner";
import * as Yup from "yup";

import doubleBubbleBackground from "../assets/images/double-bubble-outline.png";
import LoginLogo from "../assets/images/login-logo.png";
import ReactJson from "react-json-view";
import { setToLS } from "../util/storage";
import { Link, useHistory } from "react-router-dom";
import toast from "react-hot-toast";
import AppContext from "../contexts/AppContext";
import PhoneNumber from "../components/PhoneNumber";
import WithThemeWrapper from "../theme/WithThemeWrapper";
import renderComponent from "../renderComponent";

const formData = {
  name: "Sign Up",
  subcomponents: [
    {
      type: "SignUpFormStepper1",
      target_id: 64521,
      button_action: "SAVE",
      submit_action: "SIGN UP",
      button_otp: null,
      button_hide: "false",
      enableImport: null,
      enableModal: null,
      // excel_template: [
      //   {
      //     name: "ORGANIZATION_NAME",
      //     column: "NAME",
      //     property: "",
      //     id: "false",
      //     comp: "true",
      //     dup: "true",
      //   },
      // ],
      excel_template: null,
      name: "Sign Up",
      nextButtonAction: null,
      options: null,
      schema: [
        {
          name: "",
          type: "Form1",
          useCart: "false",
          options: [
            {
              target_id: 2700550,
              target: "label",
              name: "title",
              type: "label",
              label: "Organisation Details",
            },
            {
              target_id: 2700551,
              target: "text",
              name: "organization_name",
              type: "text",
              edit: "NAME",
              label: "Organization Name",
              root_1: "_SETUP",
              root_2: "NAME",
              validation: { required: true },
            },
            {
              target_id: 2700552,
              target: "select",
              name: "organization_sector",
              type: "select",
              data: "SECTOR",
              edit: "SECTOR_ID",
              label: "Organization Sector",
              root_1: "_SETUP",
              root_2: "ATTRIBUTE",
              root_3: "sector_id",
              response: "json",
              validation: { required: true },
            },
            {
              target_id: 2700553,
              target: "select",
              name: "organization_type",
              type: "select",
              data: "COMPANY TYPE",
              edit: "TYPE_ID",
              label: "Organization Type",
              root_1: "_SETUP",
              root_2: "ATTRIBUTE",
              root_3: "type_id",
              response: "json",
              validation: { required: true },
            },
            {
              target_id: 2700554,
              target: "text",
              name: "address",
              type: "text",
              edit: "ADDRESS",
              label: "Address",
              root_1: "_SETUP",
              root_2: "ATTRIBUTE",
              root_3: "address",
              response: "json",
              validation: { required: true },
            },
            {
              target_id: 2700555,
              target: "select",
              name: "location",
              type: "select",
              data: "STATE",
              edit: "LOCATION_ID",
              label: "Where is the headquarters located?",
              root_1: "_SETUP",
              root_2: "ATTRIBUTE",
              root_3: "location_id",
              response: "json",
              validation: { required: true },
            },
            {
              target_id: 2700556,
              target: "phonenumber",
              name: "phone_number",
              type: "phonenumber",
              edit: "ORG_PHONE_NUMBER",
              label: "Phone Number",
              root_1: "_SETUP",
              root_2: "ATTRIBUTE",
              root_3: "org_phone_number",
              response: "json",
              validation: { required: true },
            },
            {
              target_id: 2700557,
              target: "text",
              name: "email",
              type: "text",
              edit: "ORG_EMAIL",
              label: "Email",
              root_1: "_SETUP",
              root_2: "ATTRIBUTE",
              root_3: "org_email",
              response: "json",
              validation: { required: true },
            },
            {
              target_id: 2700558,
              target: "text",
              name: "cac_reg_no",
              type: "text",
              edit: "CODE",
              label: "CAC Registration Number",
              root_1: "_SETUP",
              root_2: "CODE",
              validation: { required: true },
            },
            {
              target_id: 2700559,
              target: "text",
              name: "scuml_reg_no",
              type: "text",
              edit: "SCUML_REG_NO",
              label: "SCUML Registration Number",
              root_1: "_SETUP",
              root_2: "ATTRIBUTE",
              root_3: "scuml_reg_no",
              response: "json",
              validation: { required: true },
            },
          ],
        },
        {
          name: "",
          type: "Form1",
          useCart: "false",
          options: [
            {
              target_id: 2700560,
              target: "label",
              name: "title",
              type: "label",
              label: "Key Representative Information",
            },
            {
              target_id: 2700561,
              target: "text",
              name: "first_name",
              type: "text",
              edit: "FIRST_NAME",
              label: "First Name",
              root_1: "_SETUP",
              root_2: "ATTRIBUTE",
              root_3: "first_name",
              response: "json",
              validation: { required: true },
            },
            {
              target_id: 2700562,
              target: "text",
              name: "last_name",
              type: "text",
              edit: "LAST_NAME",
              label: "Last Name",
              root_1: "_SETUP",
              root_2: "ATTRIBUTE",
              root_3: "last_name",
              response: "json",
              validation: { required: true },
            },
            {
              target_id: 2700563,
              target: "text",
              name: "user_email",
              type: "text",
              edit: "EMAIL",
              label: "Email",
              root_1: "_SETUP",
              root_2: "ATTRIBUTE",
              root_3: "email",
              response: "json",
              validation: { required: true },
            },
            {
              target_id: 2700564,
              target: "phonenumber",
              name: "user_phone_number",
              type: "phonenumber",
              edit: "PHONE_NUMBER",
              label: "Phone Number",
              root_1: "_SETUP",
              root_2: "ATTRIBUTE",
              root_3: "phone_number",
              response: "json",
              validation: { required: true },
            },
          ],
        },
      ],
      required: true,
      submit: {
        subcomponents: ["Save"],
      },
      subcomponents: ["Save"],
      showPreview: null,
      target_type: null,
      useCart: null,
    },
    {
      type: "SavedRecordList1",
      button_action: "SIGN UP",
      button_hide: "false",
      button_otp: null,
      enableImport: null,
      enableModal: null,
      excel_template: null,
      name: "Sign Up",
      nextButtonAction: null,
      options: [
        {
          Title: "SIGN UP",
          grid: [],
          gridtype: "vertical",
          pages: 0,
          records_per_page: 40,
          target_type: "RECORD",
        },
      ],
      preview: null,
      schema: null,
      showPreview: null,
      target_id: 91399,
      target_type: "RECORD",
    },
  ],
  ignoreButton: true,
  type: "GridAndFormStepperWrapper1",
};

const LoginContainer = styled.div`
  background: #ffffff;
`;

const LoginArea = styled.div`
  &:before,
  &:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: -2;
  }
  &:before {
    background: #fdf9eb;
  }
  &:after {
    background: url(${doubleBubbleBackground});
    background-blend-mode: multiply;
    opacity: 0.25;
    z-index: -1;
  }
`;

function SignUp({ theme, subs }) {
  const [processing, setProcessing] = useState(false);
  const history = useHistory();
  const { context, setContext } = useContext(AppContext);
  let token = localStorage.getItem("token") ?? "";

  const logo = (theme?.logo || [])[0];

  console.log("what is the current Token", token);
  console.log("the formData", formData);

  const postData = (values) =>
    new Promise((resolve, reject) => {
      setProcessing(true);
      let { userName } = values;
      userName = userName.includes("@")
        ? userName
        : Yup.string().appendCountryCode("+234").cast(userName);
      appFetch
        .post(`${apiEndpoints.login}?subs=${subs}`, {
          body: JSON.stringify({ ...values, userName }),
        })
        .then((res) => {
          console.log("value of response is", res);
          resolve(res);
        })
        .catch((err) => reject(err))
        .finally(() => setProcessing(false));
    });

  const logout = () => {
    setProcessing(true);
    appFetch
      .get(apiEndpoints.logout)
      .then((res) => {
        //const loginUrl = getFromLS("loginUrl");
        if (res?.ERROR_MESSAGE === "SUCCESS") {
          localStorage.clear();
          let pathName = window.location.pathname.slice(1).split("/")[0];
          // window.location = `/${pathName}/login`
          history.push(`/${pathName}/login`);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setProcessing(false));
  };

  return (
    <LoginArea className="min-h-screen h-full flex flex-col items-center justify-center">
      <div className="max-w-lg w-full space-y-8 -mt-5 px-4 ">
        <div>
          <img className="mx-auto h-12 w-auto" src={logo} alt={theme?.name} />
          {/* <h2 className="mt-2 text-center text-2xl font-extrabold text-custom-black-1000">Admin Portal</h2> */}
        </div>
        <LoginContainer className="rounded-lg shadow pt-8 pb-4 px-4 sm:px-6 lg:px-6 h-8/10">
          <h2 className="text-center text-2xl font-medium text-custom-black-100">
            Create your profile
          </h2>

          <p className="mt-2 text-center text-xs">
            <a
              href="#"
              className="font-normal text-custom-gray-200 hover:text-gray-300"
            >
              Enter your details to sign up
            </a>
          </p>

          <div className="max-h-[400px] md:max-h-[600px] ">
            {renderComponent(formData)}
          </div>

          <div className="flex items-center justify-center">
            <div className="text-sm text-custom-gray-200">
              Return to
              {/* <Link
                to="login"
                className="font-medium cursor-pointer"
                style={{ color: theme?.colors?.primary }}
              >
                &nbsp;Login
              </Link> */}
              <a
                onClick={logout}
                role="button"
                className="font-medium cursor-pointer"
                style={{ color: theme?.colors?.primary }}
              >
                &nbsp;Login
              </a>
            </div>
          </div>
        </LoginContainer>
      </div>
    </LoginArea>
  );
}

export default WithThemeWrapper(SignUp);
